// src/pages/feasibility/PvSizingKpi.jsx
//
// The one KPI tile the sizing uses everywhere: a label, a figure, a line
// under it, and, when there is something to compare with, the difference
// against it ("+5,3 % έναντι της σχεδίασης του έργου"). Text carries the
// comparison, with an arrow beside it; never colour alone.

import React from "react";
import { Paper, Typography } from "@mui/material";

export const HUES = { pv: "#15803d", npv: "#2563eb", irr: "#0e7490", lcoe: "#9a3412", saving: "#0f766e", capex: "#b45309", share: "#6d28d9", payback: "#475569" };

export default function PvSizingKpi({ label, value, sub, hue, warn, delta }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, borderTop: `3px solid ${warn ? "#b45309" : hue}`, height: "100%" }}>
      <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 700, letterSpacing: 0.3, textTransform: "uppercase", fontSize: 10.5 }}>{label}</Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, mt: 0.25, color: warn ? "#b45309" : "text.primary" }}>{value}</Typography>
      {sub && <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>{sub}</Typography>}
      {delta && <Typography variant="caption" data-testid="kpi-delta" sx={{ display: "block", mt: 0.25, fontWeight: 600, color: delta.better === true ? "success.main" : delta.better === false ? "warning.main" : "text.secondary" }}>
        {delta.better === true ? "▲ " : delta.better === false ? "▼ " : "■ "}{delta.text}
      </Typography>}
    </Paper>
  );
}

/** The difference of `value` from `reference` as a tile's delta: signed text
 * and whether it is the better side (`higherIsBetter`; `neutral` for a figure
 * with no better side, such as the size). Null without a reference. */
export function kpiDelta(value, reference, { higherIsBetter = true, neutral = false, format, against = "" }) {
  if (!Number.isFinite(value) || !Number.isFinite(reference)) return null;
  const diff = value - reference;
  const tail = against ? ` ${against}` : "";
  if (Math.abs(diff) < 1e-9) return { text: `${format(0)}${tail}`, better: null };
  const sign = diff > 0 ? "+" : "−";
  return { text: `${sign}${format(Math.abs(diff))}${tail}`, better: neutral ? null : diff > 0 ? higherIsBetter : !higherIsBetter };
}
